import { useSearchParams } from "react-router-dom";
// types
// import { type IsDisabledFilter, type IsConfirmedFilter } from "../lib/types";
type IsDisabledFilter = any;
type IsConfirmedFilter = any;
// constants
const IS_DISABLED_DEFAULT_VALUE = "is_disabled:eq:false";
const IS_CONFIRMED_DEFAULT_VALUE = "is_confirmed:eq:true|false";
const IS_HOST_DEFAULT_VALUE = "is_host:eq:true|false";
const FROM_DEFAULT_VALUE = "";
const TO_DEFAULT_VALUE = "";
const RESERVATION_STATUS_DEFAULT_VALUE = "all";
const RESERVATION_ROLE_DEFAULT_VALUE = "all";
const SETTLEMENT_STATUS_DEFAULT_VALUE = "status:eq:completed|rejected|pending";
const HOST_REGISTRATION_STATUS_DEFAULT_VALUE =
  "status:eq:completed|rejected|pending";
const CITY_FILTER_ID = "";
const PROPERTY_TYPE_FILTER_ID = "";
const IS_MULTI_UNIT_DEFAULT_VALUE = "is_multi_unit:eq:true|false";

const useFilterParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isDisabled =
    searchParams.get("isDisabled") || IS_DISABLED_DEFAULT_VALUE;

  const isConfirmed =
    searchParams.get("isConfirmed") || IS_CONFIRMED_DEFAULT_VALUE;

  const isHost = searchParams.get("isHost") || IS_HOST_DEFAULT_VALUE;

  const reservationStatus =
    searchParams.get("reservationStatus") || RESERVATION_STATUS_DEFAULT_VALUE;

  const reservationRole =
    searchParams.get("reservationRole") || RESERVATION_ROLE_DEFAULT_VALUE;

  const settlementStatus =
    searchParams.get("settlementStatus") || SETTLEMENT_STATUS_DEFAULT_VALUE;

  const registrationStatus =
    searchParams.get("registrationStatus") ||
    HOST_REGISTRATION_STATUS_DEFAULT_VALUE;

  const from = searchParams.get("from") || FROM_DEFAULT_VALUE;
  const to = searchParams.get("to") || TO_DEFAULT_VALUE;

  const cityId = searchParams.get("city_id") || CITY_FILTER_ID;
  const propertyTypeId =
    searchParams.get("property_type_id") || PROPERTY_TYPE_FILTER_ID;

  const isMultiUnit =
    searchParams.get("isMultiUnit") || IS_MULTI_UNIT_DEFAULT_VALUE;

  const setIsDisabled = (value: IsDisabledFilter) => {
    searchParams.set("isDisabled", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setIsConfirmed = (value: IsConfirmedFilter) => {
    searchParams.set("isConfirmed", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setIsHost = (value: any) => {
    searchParams.set("isHost", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setReservationStatus = (value: any) => {
    searchParams.set("reservationStatus", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setReservationRole = (value: string) => {
    searchParams.set("reservationRole", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setSettlementsStatus = (value: any) => {
    searchParams.set("settlementStatus", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setRegistrationStatus = (value: any) => {
    searchParams.set("registrationStatus", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setFrom = (value: string) => {
    searchParams.set("from", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setTo = (value: string) => {
    searchParams.set("to", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setCityId = (value: string) => {
    searchParams.set("city_id", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setPropertyTypeId = (value: string) => {
    searchParams.set("property_type_id", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  const setIsMultiUnit = (value: string) => {
    searchParams.set("isMultiUnit", value);
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };

  return {
    isDisabled,
    setIsDisabled,
    isConfirmed,
    setIsConfirmed,
    from,
    setFrom,
    to,
    setTo,
    isHost,
    setIsHost,
    reservationStatus,
    setReservationStatus,
    reservationRole,
    setReservationRole,
    settlementStatus,
    setSettlementsStatus,
    registrationStatus,
    setRegistrationStatus,
    cityId,
    setCityId,
    propertyTypeId,
    setPropertyTypeId,
    isMultiUnit,
    setIsMultiUnit,
  };
};

export default useFilterParams;
